var Raphael = require('raphael'),
    _ = require('underscore'),
    BaseResize = require('../baseShapeResizeFns');

/*
 * Currently used for a lines types and polygon redactions.
 * This involves dragging a 'point' on a polygon,
 * then resizing the polygon to reflect the change in size from the drag.
 * Context for all these is shape view.
 * TODO:
 *   - Now using inherited mixins and composition where necessary -- these should all be on shape view prototypes ...
 *   - further cleanup this old mess
 *   - 'Draw helper' objects would be more helpful as well instead of setting all these directly on the mixed-in-shapes.
 * */


module.exports = {

    resizeStart: function(x, y, e) {

        if ( !BaseResize.start.apply( this, arguments) )
            return false;

        this.currentPts = this.el.getPathCoordinates();

        this.dragPoint = this.currentPts[ this.dragHandle.data('ptIndex') ];  // a reference to the pt coordinate corresponding to the drag handle

        // Store the original position of the drag point and drag handle
        _.extend( this.dragPoint, {
            ox: this.dragPoint.x,
            oy: this.dragPoint.y
        });

        _.extend( this.dragHandle, {
            ox: this.dragHandle.attr('cx'),
            oy: this.dragHandle.attr('cy')
        });

        this.trigger( 'shape.poly.resizeStart' );

        return true;
    },

    resizeMove: function( dx, dy, x, y, e ) {

        if ( !BaseResize.move.apply( this, arguments ) )
            return false;

        this.updateDragPtHandleAndPathOnMove.apply( this, arguments );

        this.trigger( 'shape.poly.resize' );

        return true;

    },

    resizeEnd: function( e ) {

        if ( !BaseResize.end.call( this, e) )
            return false;

        BaseResize.cleanUp.call(this);

        this.dragPoint = null;
        this.currentPts = null;

        this.trigger('shape.resizePolyEnd', this.el.getBBox() );

        return true;

    },

   /*
   * Update the dragHandle and the path getting dragged.
   * Data is updated on dragPoint, which is later used to update the path in the DOM.
   * The default action here, no shift key, etc.
   * More flexibility would be creation of more objects, fns (eg here we have updatePath) ...
   * */
   updateDragPtHandleAndPathOnMove: function( dx, dy, x, y, e ) {

       var dp = this.dragPoint;

       _.extend( this.dragPoint, {
           x: dp.ox + dx,
           y: dp.oy + dy
       });

       this.dragHandle.attr({
           cx: dp.ox + dx,
           cy: dp.oy + dy
       });

       this.updatePath.call( this, e );

    },

    // Default Behavior -- Override If Necessary
    updatePath: function() {
        this.el.setPathFromPtsArray( this.currentPts, 0 );
    }

};





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/resizeFns/poly/base.js
 ** module id = 201
 ** module chunks = 0
 **/